var map = {
	"./bug_bg.svg": 103,
	"./dark_bg.svg": 5399,
	"./dragon_bg.svg": 1938,
	"./electric_bg.svg": 7722,
	"./fairy_bg.svg": 9720,
	"./fighting_bg.svg": 1156,
	"./fire_bg.svg": 6641,
	"./flying_bg.svg": 814,
	"./ghost_bg.svg": 4934,
	"./grass_bg.svg": 5329,
	"./ground_bg.svg": 3190,
	"./ice_bg.svg": 5028,
	"./normal_bg.svg": 4940,
	"./poison_bg.svg": 5006,
	"./psychic_bg.svg": 8095,
	"./rock_bg.svg": 155,
	"./steel_bg.svg": 70,
	"./water_bg.svg": 4515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8501;